import waRequest from './wa-request';

const cancelableAirlinesSingleton = waRequest.createCancelableSingleton();

export const baseApi = '/airlines/v1';

/**
 * Download airlines intel report.
 *
 * @param {Object} config
 * @param {Object} [config.params]
 * @param {string} [config.params.locale]
 * @param {string} [config.params.type] — CSV or XLSX
 */
function getAirlinesReport(config) {
  const {
    params: {
      locale,
      type,
      sort,
      organizationId,
      nameSearch,
      iataCodeSearch,
      descriptionSearch,
      countryId,
      rating,
      operationalStatus,
      airlinesWithClientRatings,
    } = {},
    signal,
  } = config;

  const url = `${baseApi}/airlines/report`;

  return waRequest.requestAuthenticated({
    url,
    method: 'get',
    responseType: 'blob',
    params: {
      locale,
      type,
      sort,
      organizationId,
      nameSearch,
      iataCodeSearch,
      descriptionSearch,
      countryId,
      rating,
      operationalStatus,
      airlinesWithClientRatings,
    },
    signal,
  });
}

function airlineSearchList({
  params: {
    organizationId,
    iataCodeSearch,
    nameSearch,
    airlineId,
    countryId,
    operationalStatus,
    descriptionSearch,
    rating,
    locale,
    page,
    size,
    sort,
    airlinesWithClientRatings,
  },
  signal,
}) {
  const url = `${baseApi}/airlines/search`;

  return waRequest.requestAuthenticated({
    url,
    method: 'get',
    params: {
      organizationId,
      iataCodeSearch,
      nameSearch,
      airlineId,
      countryId,
      operationalStatus,
      descriptionSearch,
      rating,
      locale,
      page,
      size,
      sort,
      airlinesWithClientRatings,
    },
    signal,
  });
}

function updateAirlinesRatings({pathParams: {airlineId}, params, data}) {
  const url = `${baseApi}/airlines/${airlineId}/custom-rating`;

  return waRequest.requestAuthenticated({
    url: url,
    method: 'PUT',
    params,
    data,
  });
}

function getOrganizationAirlinesCustomRatingConfig({pathParams}) {
  const {organizationId} = pathParams;
  const url = `${baseApi}/airlines/${organizationId}/custom-ratings-config`;

  return waRequest.requestAuthenticated({
    url: url,
    method: 'get',
  });
}

function getAirlines({params = {}}) {
  const url = `${baseApi}/airlines`;

  const {nameSearch, iataCodeSearch, descriptionSearch} = params;

  return cancelableAirlinesSingleton.requestAuthenticated({
    url: url,
    method: 'get',
    params: {
      sort: 'name,asc',
      nameSearch: nameSearch,
      iataCodeSearch: iataCodeSearch,
      descriptionSearch: descriptionSearch,
    },
  });
}

export default {
  getAirlinesReport,
  airlineSearchList,
  updateAirlinesRatings,
  getOrganizationAirlinesCustomRatingConfig,
  getAirlines,
};
